import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    StepperStepDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    surface: {
        alignItems: "flex-start",
        flexDirection: "row",
        minWidth: 0
    },
    vertical: {
        alignSelf: "stretch"
    },
    horizontal: {
        flexShrink: 1,
        flexGrow: 0,
        minWidth: 0
    }
});

export const useStyles = ({
    isFocusVisible,
    isHorizontal,
    shapeConfigs,
    measures,
    radiuses,
    borders,
    colors,
    spaces
}: StepperStepDynamicStyleType) => {
    const styles = {
        surface: {
            paddingEnd: isHorizontal ? spaces.spacingSm : measures.controlPadding,
            paddingVertical: (measures.rowHeight - measures.markerSize) / 2,
            ...getCornerStyle({
                radius: radiuses.actions,
                shapeConfigs
            }),
            minHeight: measures.rowHeight,
            gap: measures.controlPadding,
            paddingStart: measures.inset
        } as Mutable<ViewStyle>,
        container: {
            minHeight: measures.rowHeight
        } as Mutable<ViewStyle>
    };

    Object.assign(styles.surface, getFocusRingStyle({
        colorKey: "default",
        isFocusVisible,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
